import { RoleAction } from "src/Api/Enum/Role";
import { TableName } from "../table";
import type { CustomerPermission, TablePermission } from "./permission";
import {
  PermissionFactory,
  CRUD,
  VIEW_ONLY
} from "./permission";

export const superUserPermission = (
  customerPermissions: CustomerPermission[] = [],
  userRoles: string[] = [],
): TablePermission => ({
  [TableName.View]: [
    PermissionFactory.buildPermission(RoleAction.VIEW),
    PermissionFactory.buildPermission(RoleAction.SHARE_VIEW_TO_USER),
    PermissionFactory.buildPermission(RoleAction.SHARE_VIEW_TO_GROUP),
    PermissionFactory.buildPermission(RoleAction.CREATE),
  ],

  [TableName.ViewPom]: VIEW_ONLY,

  [TableName.ViewWelcomePage]: [
    PermissionFactory.buildPermission(RoleAction.VIEW),
    PermissionFactory.buildPermission(RoleAction.VIEW_OVERVIEW),
    PermissionFactory.buildFeaturePermission(
      RoleAction.SUMMARY_REPORT, "SUMMARY_REPORT", customerPermissions, userRoles
    ),
    PermissionFactory.buildPermission(RoleAction.VIEW_CREATE),
  ],

  [TableName.Profile]: CRUD,

  [TableName.DisplayPom]: VIEW_ONLY,

  [TableName.Tag]: [
    ...CRUD,
    PermissionFactory.buildPermission(RoleAction.SELECTION_TAG),
  ],

  [TableName.Pom]: VIEW_ONLY,

  [TableName.Location]: VIEW_ONLY,

  [TableName.User]: [
    PermissionFactory.buildPermission(RoleAction.VIEW),
    PermissionFactory.buildPermission(RoleAction.UPDATE, ["customerId"]),
    PermissionFactory.buildPermission(RoleAction.SEND_INVITATION),
    PermissionFactory.buildPermission(RoleAction.USER_PERMISSION),
  ],

  [TableName.UserGroup]: CRUD,

  [TableName.ChangePassword]: VIEW_ONLY,

  [TableName.MapLocation]: CRUD,

  [TableName.Manage]: VIEW_ONLY,

  [TableName.LegalInfo]: [
    PermissionFactory.buildFeaturePermission(
      RoleAction.VIEW, "PRIVACY_SECTION", customerPermissions, userRoles
    ),
  ],
  [TableName.LocationStatus]: VIEW_ONLY,
  [TableName.Impersonation]: [
    PermissionFactory.buildPermission(RoleAction.IMPERSONATION),
  ],
  [TableName.DisplayView]: [
    ...CRUD,
    PermissionFactory.buildPermission(RoleAction.SHARE_VIEW_TO_USER),
    PermissionFactory.buildPermission(RoleAction.SHARE_VIEW_TO_GROUP),
    PermissionFactory.buildFeaturePermission(
      RoleAction.DELETE_VIEW_ADVANCED, "DELETE_VIEW_ADVANCED", customerPermissions, userRoles
    ),
  ],

  [TableName.Ticketing]: [
    PermissionFactory.buildFeaturePermission(
      RoleAction.VIEW, "TICKETING", customerPermissions, userRoles
    ),
    PermissionFactory.buildFeaturePermission(
      RoleAction.CREATE, "TICKETING", customerPermissions, userRoles
    ),
    PermissionFactory.buildPermission(RoleAction.DIFFERENT_CUSTOMER_POM),
  ],
  [TableName.HeadcounterSensor]: VIEW_ONLY,
  [TableName.Area]: VIEW_ONLY,
  [TableName.Category]: VIEW_ONLY,
  [TableName.Industry]: VIEW_ONLY
});